import { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { createContext } from "react";

export const IndividualLoginAuth0Context = createContext<
  Auth0ContextInterface<User>
>({} as Auth0ContextInterface<User>);
